import React, { useState, useEffect } from "react"; // ✅ Added useState
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Modal, Button } from "react-bootstrap"; // 👈 added for modal

import arif from "../../Images/testimonials/arif.webp";
import sonu from "../../Images/testimonials/sonu.webp";
import yogita from "../../Images/testimonials/1701A010137.webp";
import teenu from "../../Images/testimonials/1702A010279.webp";
import gajendra from "../../Images/testimonials/1702A010427.webp";
import topeshwar from "../../Images/testimonials/1702A020495.webp";
import himalaya from "../../Images/testimonials/1801A020678.webp";
import jagriti from "../../Images/testimonials/1801A021590.webp";
import hemant from "../../Images/testimonials/2102A0300411.webp";
import chhaya from "../../Images/testimonials/2201A0100432.webp";
import durgeshwari from "../../Images/testimonials/2201A0300341.webp";
import abhishek_bca from "../../Images/testimonials/2202A0100195.webp";
import kuleshwar from "../../Images/testimonials/2202A0100956.webp";
import niranjan from "../../Images/testimonials/2202A0200756.webp";
import suresh from "../../Images/testimonials/2202A0201068.webp";
import isha from "../../Images/testimonials/2301A0100157.webp";
import ekta from "../../Images/testimonials/2301A0100360.webp";
import gitika from "../../Images/testimonials/2301A0202771.webp";
import vamini from "../../Images/testimonials/2301A0203109.webp";
import naveen from "../../Images/testimonials/2302A0100211.webp";
import hemant_k from "../../Images/testimonials/2302A0101025.webp";
import guruvachan from "../../Images/testimonials/2302A0102279.webp";
import yogesh_c from "../../Images/testimonials/2302A0102290.webp";
import devid from "../../Images/testimonials/2302A0102920.webp";
import aashish_d from "../../Images/testimonials/2302A0102930.webp";
import yogesh_d from "../../Images/testimonials/2302A0201854.webp";
import yash from "../../Images/testimonials/2302A0202659.webp";
import aastha from "../../Images/testimonials/2401A0100036.webp";
import sunita from "../../Images/testimonials/2401A0100161.webp";
import gunjan from "../../Images/testimonials/2401A0100238.webp";
import hemlata from "../../Images/testimonials/2401A0100584.webp";
import palak from "../../Images/testimonials/2401A0100587.webp";
import roshanee from "../../Images/testimonials/2401A0100862.webp";
import bushra from "../../Images/testimonials/2401A0200027.webp";
import suman from "../../Images/testimonials/2401A0201800.webp";
import divya_s from "../../Images/testimonials/2401A0202013.webp";
import yeshu from "../../Images/testimonials/2402A0100026.webp";
import lakhan from "../../Images/testimonials/2402A0100153.webp";
import dikshit from "../../Images/testimonials/2402A0100195.webp";
import kartik from "../../Images/testimonials/2402A0100310.webp";
import vikas from "../../Images/testimonials/2402A0100378.webp";
import akshat from "../../Images/testimonials/2402A0100427.webp";
import lukesh from "../../Images/testimonials/2402A0100512.webp";
import ojasva from "../../Images/testimonials/2402A0100847.webp";
import praveen from "../../Images/testimonials/2402A0100863.webp";
import bedram from "../../Images/testimonials/2402A0100973.webp";
import aashish_k from "../../Images/testimonials/2402A0101246.webp";
import riyansh from "../../Images/testimonials/2402A0101771.webp";
import bhaskar from "../../Images/testimonials/2402A0101869.webp";
import piyush from "../../Images/testimonials/2402A0201606.webp";
import tukeshwar from "../../Images/testimonials/2402A0201831.webp";
import gajanand from "../../Images/testimonials/2402A0201867.webp";
import kavita from "../../Images/testimonials/kavita.webp";
import vrishti from "../../Images/testimonials/vrishti.webp";
import pushpendra from "../../Images/testimonials/pushpendra.webp";
import sakshi from "../../Images/testimonials/sakshi.webp";
import gaurav from "../../Images/testimonials/gaurav.webp";
import abhisheksingh from "../../Images/testimonials/abhishek.webp";
import kevil from "../../Images/testimonials/kevil.webp";
import amit from "../../Images/testimonials/amit.webp";
import divya from "../../Images/testimonials/divya.webp";
// import sumit from "../../Images/testimonials/user.webp";
import tilendra from "../../Images/testimonials/tilendra.webp";
// import na from "../../Images/testimonials/user.webp";
import satya from "../../Images/testimonials/SATYA PATEL (MSc MICROBIOLOGY).webp";
import ayush from "../../Images/testimonials/AYUSH RANJAN SINGH (B.TECH MINING).webp";
import narayan from "../../Images/testimonials/NARAYAN MOHANTY (B.TECH MINING).webp";
import pravriti from "../../Images/testimonials/PRAVRITI PANDEY (MBA).webp";
import devrat from "../../Images/testimonials/DEVVRAT BAG(BBA.LLB).webp";

import "../../home2.css";

const AlumniSec = () => {   
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const alumniData = [
    {
      id: 1,
      name: "MD Arif",
      field: "",
      testimonial:
        "I am incredibly grateful to ISBM University for providing me with the opportunity to secure my dream job. The university not only equipped me with essential skills but also nurtured my potential for growth.",
      image: arif,
    },
    {
      id: 2,
      name: "Shivam Pandey",
      field: "",
      testimonial:
        "My journey with ISBM University has been both enriching and empowering. The in-depth curriculum and dedicated faculty provided me with skills to thrive in the industry.",
      image: sonu,
    },
    {
      id: 3,
      name: "Kavita Sahu",
      field: "BBA ",
      testimonial:
        "The BBA program at ISBMU gave me strong business knowledge and real industry exposure. The faculty are supportive, and the projects and internships helped me gain confidence and practical skills. ISBMU has truly prepared me for my career.",
      image: kavita,
    },
    {
      id: 4,
      name: "Vrishti Upadhyay",
      field: "BBA.LLB ",
      testimonial:
        "Studying BBA.LLB at ISBMU has been a great experience. The teachers are supportive, and the mix of law and management has helped me learn both theory and practical skills. I feel more confident about my future here.",
      image: vrishti,
    },
    {
      id: 5,
      name: "Gaurav Soni",
      field: "MSc Chemistry ",
      testimonial:
        "My MSc Chemistry at ISBMU has been very good. Teachers are helpful, labs are well equipped, and I have learned a lot. It is a great place to study.",
      image: gaurav,
    },
    {
      id: 6,
      name: "Sakshi Bisen",
      field: "B.Tech IT ",
      testimonial:
        "My journey in B.Tech IT at ISBMU has been full of learning and growth. The coding sessions, labs, and projects gave me real practical knowledge. The teachers always guide us and make learning easy.",
      image: sakshi,
    },
    {
      id: 7,
      name: "Pushpendra Singh",
      field: "Library Science ",
      testimonial:
        "The Library Science course at ISBM University gave me good knowledge of books, digital resources, and library management. The teachers are helpful and the course is very practical. It has prepared me well for future jobs.",
      image: pushpendra,
    },
    {
      id: 8,
      name: "Abhishek Singh",
      field: "BBA ",
      testimonial:
        "Studying BBA at ISBM University has been a good experience. The course gave me clear knowledge of management and business concepts. The faculty are supportive and guide us well, which makes learning easier and more practical.",
      image: abhisheksingh,
    },
    {
      id: 9,
      name: "Kevil Kumar Devanga ",
      field: "School of Arts ",
      testimonial:
        "The School of Arts at ISBM University gave me the chance to explore my creativity and learn new skills. The classes are interactive, the teachers are encouraging, and I gained confidence to express myself better through art.",
      image: kevil,
    },
    {
      id: 10,
      name: "Amit Sahu",
      field: "B.Sc ",
      testimonial:
        "The B.Sc. program at ISBM University helped me build strong knowledge in science subjects. The teachers explain concepts clearly, and the practical sessions made learning more interesting and useful for my future career.",
      image: amit,
    },
    {
      id: 11,
      name: "Divya Patel",
      field: "M.Sc Microbiology ",
      testimonial:
        "Studying M.Sc. Microbiology at ISBM University has been a good experience. The labs are well equipped, and the staff and admin are always supportive. The campus has good facilities which make learning easy.",
      image: divya,
    },
    {
      id: 12,
      name: "Tukeshwar Sahu",
      field: "M.Sc Chemistry ",
      testimonial:
        "M.Sc. Chemistry here helped me love experiments and research. The support was always there.",
      image: tukeshwar,
    },
    {
      id: 13,
      name: "Tilendra Kumar",
      field: "PGDCA ",
      testimonial:
        "The PGDCA program at ISBM University gave me good knowledge of computer applications. The teachers guide us well, the staff are supportive, and the labs have all the facilities needed for practical learning.",
      image: tilendra,
    },
    {
      id: 14,
      name: "Gajanand",
      field: "M.Lib ",
      testimonial:
        "My MLIB course gave me advanced skills and confidence. ISBM University made me ready for the professional world.",
      image: gajanand,
    },
    {
      id: 15,
      name: "Yogita Sen",
      field: "B.Sc ",
      testimonial:
        "ISBM University has given me the right environment to explore science. The teachers always encourage us to ask questions, and I feel more confident about my future.",
      image: yogita,
    },
    {
      id: 16,
      name: "Teenu Anand",
      field: "B.Sc ",
      testimonial:
        "My journey in B.Sc. has been wonderful. I have received not only knowledge, but also guidance and care from teachers who treat us like family.",
      image: teenu,
    },
    {
      id: 17,
      name: "Gajendra Kumar Dhruw ",
      field: " B.Sc Computer Science ",
      testimonial:
        "The computer labs, supportive staff, and practical approach at ISBM University have helped me grow in confidence. I can now dream bigger in the field of IT.",
      image: gajendra,
    },
    {
      id: 18,
      name: "Topeshwar Prasad",
      field: "M.Sc Botany ",
      testimonial:
        "Studying Botany here has connected me with nature and research. The modern labs and helpful faculty made every experiment meaningful.",
      image: topeshwar,
    },
    {
      id: 19,
      name: "Himalaya Sahu",
      field: "M.Sc Zoology ",
      testimonial:
        "My Zoology course at ISBM University gave me more than academic knowledge—it gave me passion for research and respect for my subject.",
      image: himalaya,
    },
    {
      id: 20,
      name: "Jagriti",
      field: "M.Sc Botany ",
      testimonial:
        "At ISBM University, I always felt supported. The faculty’s personal attention made me believe that I can achieve more in the field of Botany.",
      image: jagriti,
    },
    {
      id: 21,
      name: "Hemant",
      field: "PGDCA ",
      testimonial:
        "The PGDCA program gave me the confidence to handle real computer applications. Every class felt practical, and the staff encouraged me to keep learning.",
      image: hemant,
    },
    {
      id: 22,
      name: "Chhaya Sahu",
      field: "BCA ",
      testimonial:
        "My BCA journey at ISBM University has been exciting. From the first day, I felt motivated to learn technology in a creative way.",
      image: chhaya,
    },
    {
      id: 23,
      name: "Durgeshwari Sahu ",
      field: "B.Lib ",
      testimonial:
        "Library Science here gave me more than knowledge—it gave me pride in managing information and helping others learn.",
      image: durgeshwari,
    },
    {
      id: 24,
      name: "Abhishek",
      field: "BCA ",
      testimonial:
        "ISBM University gave me the chance to explore the IT world with real guidance. I feel prepared to face challenges in the industry.",
      image: abhishek_bca,
    },
    {
      id: 25,
      name: "Kuleshwar Kumar",
      field: "B.Sc ",
      testimonial:
        "My time in B.Sc. has been full of growth. The friendly environment and helpful teachers made me enjoy every subject.",
      image: kuleshwar,
    },
    {
      id: 26,
      name: "Niranjan Singh Nayak",
      field: "MBA ",
      testimonial:
        "The MBA program shaped me into a confident leader. The teaching at ISBM University connects theory with real business practices.",
      image: niranjan,
    },
    {
      id: 27,
      name: "Suresh Kumar",
      field: "MBA ",
      testimonial:
        "I never imagined learning could be this engaging. ISBM University gave me both knowledge and a network of mentors who inspire me.",
      image: suresh,
    },
    {
      id: 28,
      name: "Isha",
      field: "B.Sc ",
      testimonial:
        "ISBM University has been like a second home. The supportive staff and positive energy around the campus made my B.Sc. journey memorable.",
      image: isha,
    },
    {
      id: 29,
      name: "Ekta Tripathi",
      field: "BA LLB ",
      testimonial:
        "Law is not just about books, it’s about justice. At ISBM University, I learned to connect law with real life, thanks to amazing faculty support.",
      image: ekta,
    },
    {
      id: 30,
      name: "Gitika Chouhan",
      field: "MBA ",
      testimonial:
        "My MBA journey here has been life-changing. The confidence and exposure I got at ISBM University will always stay with me.",
      image: gitika,
    },
    {
      id: 31,
      name: "Vamini Sahu ",
      field: "B.Lib ",
      testimonial:
        "Through BLIB, I discovered my passion for managing knowledge. ISBM University gave me respect for books and digital resources alike.",
      image: vamini,
    },
    {
      id: 32,
      name: "Naveen Giri Goswami",
      field: "BCA ",
      testimonial:
        "The BCA course gave me not just computer skills, but also the courage to think innovatively. ISBM University made me believe in myself.",
      image: naveen,
    },
    {
      id: 33,
      name: "Hemant Kumar",
      field: "B.Com ",
      testimonial:
        "Studying commerce here gave me clarity and vision for my career. ISBM University shaped my path step by step.",
      image: hemant_k,
    },
    {
      id: 34,
      name: "Guruvachan Singh",
      field: "BCA ",
      testimonial:
        "The environment at ISBM University is so positive that learning feels natural. My BCA journey has been filled with growth.",
      image: guruvachan,
    },
    {
      id: 35,
      name: "Yogesh Kumar Chakradhari",
      field: "BCA ",
      testimonial:
        "ISBM University gave me real confidence in IT. Every project, every lab session added value to my journey.",
      image: yogesh_c,
    },
    {
      id: 36,
      name: "Devid Sahu",
      field: "LLB ",
      testimonial:
        "My dream to study law came true here. The guidance from professors made me realize the true value of justice and responsibility.",
      image: devid,
    },
    {
      id: 37,
      name: "Aashish Kumar Dewangan ",
      field: "LLB ",
      testimonial:
        "Every lecture at ISBM University inspired me to respect the law. This place gave me discipline along with education.",
      image: aashish_d,
    },
    {
      id: 38,
      name: "Yogesh Kumar Dahariya",
      field: "M.Sc Chemistry ",
      testimonial:
        "My love for Chemistry grew stronger here. The labs and faculty made every concept real and exciting.",
      image: yogesh_d,
    },
    {
      id: 39,
      name: "Yash Kumar",
      field: "MBA ",
      testimonial:
        "The MBA program taught me leadership, decision-making, and confidence. ISBM University feels like the right stepping stone for success.",
      image: yash,
    },
    {
      id: 40,
      name: "Aastha Dubey",
      field: "B.Com ",
      testimonial:
        "I gained both academic and life skills in my B.Com. journey. ISBM University is truly a place that shapes careers.",
      image: aastha,
    },
    {
      id: 41,
      name: "Sunita",
      field: "B.A ",
      testimonial:
        "The B.A. program taught me new perspectives on life. The friendly teachers at ISBM University encouraged me every step of the way.",
      image: sunita,
    },
    {
      id: 42,
      name: "Gunjan Sahu",
      field: "B.Com ",
      testimonial:
        "Studying commerce here gave me confidence in accounting and finance. ISBM University opened doors for my future.",
      image: gunjan,
    },
    {
      id: 43,
      name: "Hemlata",
      field: "B.A ",
      testimonial:
        "ISBM University gave me the courage to express my ideas and grow as an arts student.",
      image: hemlata,
    },
    {
      id: 44,
      name: "Palak Thakur",
      field: "B.Sc ",
      testimonial:
        "My B.Sc. journey was filled with experiments, projects, and wonderful memories. The staff at ISBM University always supported me.",
      image: palak,
    },
    {
      id: 45,
      name: "Roshanee Sahu",
      field: "B.A ",
      testimonial:
        "I feel proud to be a student here. ISBM University made me believe in myself and my abilities.",
      image: roshanee,
    },
    {
      id: 46,
      name: "Bushra Khan",
      field: "MBA ",
      testimonial:
        "My MBA experience taught me that learning never ends. The exposure and guidance from ISBM University shaped my career goals.",
      image: bushra,
    },
    {
      id: 47,
      name: "Suman Mannade",
      field: " M.Sc Zoology ",
      testimonial:
        "Studying Zoology here made me value science deeply. ISBM University has truly enriched my academic life.",
      image: suman,
    },
    {
      id: 48,
      name: "Divya Sahu",
      field: "M.Sc Zoology ",
      testimonial:
        "The personal attention from teachers gave me the courage to work harder. My ISBM University journey has been inspiring.",
      image: divya_s,
    },
    {
      id: 49,
      name: "Yeshu Verma",
      field: "BA LLB ",
      testimonial:
        "ISBM University showed me how law connects to society. The course made me stronger as a student and individual.",
      image: yeshu,
    },
    {
      id: 50,
      name: "Lakhan Lal Baghel",
      field: "LLB ",
      testimonial:
        "My dream of becoming a lawyer feels real now. The faculty at ISBM University guided me like mentors.",
      image: lakhan,
    },
    {
      id: 51,
      name: "Dikshit Kumar Sinha",
      field: "B.A ",
      testimonial:
        "ISBM University gave me new ideas and a chance to express myself in my B.A. studies.",
      image: dikshit,
    },
    {
      id: 52,
      name: "Kartik Yadav",
      field: "BA LLB ",
      testimonial:
        "BA LLB at ISBM University gave me both knowledge and the spirit to stand for justice.",
      image: kartik,
    },
    {
      id: 53,
      name: "Vikas Dubey",
      field: "B.A ",
      testimonial:
        "My B.A. course helped me grow as a thinker. ISBM University always encouraged me.",
      image: vikas,
    },
    // {
    //   id: 54,
    //   name: "Akshat Jakhmola",
    //   field: "B.Pharm ",
    //   testimonial:
    //     "Studying Pharmacy here has been exciting. The practical labs gave me confidence to serve in the healthcare field.",
    //   image: akshat,
    // },
    {
      id: 55,
      name: "Lukesh Kumar",
      field: "B.A ",
      testimonial:
        "My experience at ISBM University has been enriching. The teachers always motivated me to do better.",
      image: lukesh,
    },
    {
      id: 56,
      name: "Ojasva Chandrakar",
      field: "B.Sc ",
      testimonial:
        "The B.Sc. program gave me knowledge and discipline. ISBM University made learning enjoyable.",
      image: ojasva,
    },
    {
      id: 57,
      name: "Praveen Kumar Sahu",
      field: "B.A ",
      testimonial:
        "My B.A. journey has been full of encouragement. The staff here treat us with warmth and care.",
      image: praveen,
    },
    {
      id: 58,
      name: "Bedram Sahu",
      field: "B.Lib ",
      testimonial:
        "ISBM University gave me pride in learning Library Science. It has shaped my interest in managing knowledge.",
      image: bedram,
    },
    {
      id: 59,
      name: "Aashish Kumar",
      field: "LLB ",
      testimonial:
        "The LLB program gave me clarity about my future. ISBM University provided everything I needed to grow.",
      image: aashish_k,
    },
    {
      id: 60,
      name: "Riyansh Mittal",
      field: "B.Com ",
      testimonial:
        "Studying commerce here has given me both confidence and career focus. ISBM University changed my outlook.",
      image: riyansh,
    },
    {
      id: 61,
      name: "Bhaskar",
      field: "B.Lib ",
      testimonial:
        "My BLIB course taught me responsibility in managing knowledge. ISBM University gave me confidence for the future.",
      image: bhaskar,
    },
    {
      id: 62,
      name: "Piyush Yadav",
      field: "M.Sc Physics ",
      testimonial:
        "Physics felt alive in the labs at ISBM University. My professors made every concept meaningful.",
      image: piyush,
    },
    {
      id: 63,
      name: "Satya Patel",
      field: "M.Sc Microbiology ",
      testimonial:
        "My M.Sc. Microbiology journey at ISBM University has been full of learning and discovery. The well-equipped labs, supportive teachers, and caring staff made me feel confident and motivated. ISBM gave me both knowledge and memorable experiences that will always stay with me.",
      image: satya, // make sure you have imported satya image
    },
    {
      id: 64,
      name: "Ayush Ranjan",
      field: "B.Tech Mining ",
      testimonial:
        "Studying B.Tech Mining at ISBM University has been an exciting experience. The practical exposure, modern labs, and guidance from teachers gave me real confidence to work in the mining field. The support from staff and the friendly environment made my journey memorable.",
      image: ayush, // import ayush image
    },
    {
      id: 65,
      name: "Narayan Mohanty ",
      field: " B.Tech Mining ",
      testimonial:
        "My journey at ISBM University has been a good one. The teachers, labs, and staff support made learning easy and useful for my future.",
      image: narayan, // import narayan image
    },
    {
      id: 66,
      name: "Pravriti Pandey",
      field: "MBA ",
      testimonial:
        "My MBA journey at ISBM University has been very meaningful. The teachers explained concepts clearly, the staff were supportive, and the campus gave me confidence to grow in my career.",
      image: pravriti, // import pravriti image
    },
    {
      id: 67,
      name: "Devrat Bag",
      field: "BBA LLB ",
      testimonial:
        "The BBA LLB journey at ISBM University has been a great experience. The faculty guided me well in both management and law, and the supportive staff made learning comfortable and easy.",
      image: devrat, // import devrat image
    },
  ];

  const [selectedAlumni, setSelectedAlumni] = useState(null); // 👈 store clicked alumni
  const [showModal, setShowModal] = useState(false); // 👈 modal visibility

  const handleShowModal = (alumni) => {
    setSelectedAlumni(alumni);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAlumni(null);
  };

  return (
    <section
      className="alumni-section ptb-50"
      style={{ backgroundColor: "var(--primary-color)" }}
    >
      <div className="container-xxl">
        <h2 className="modern-title text-white mb-5 pb-0">
          From Campus to Career Success - Leading<br /> Voices of Our Alumni
        </h2>

        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={
            !isMobile
              ? {
                clickable: true,
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
              }
              : false
          }
          breakpoints={{
            768: { slidesPerView: 2 },
            992: { slidesPerView: 4 },
          }}
          className="pb-5"
        >
          {alumniData.map((alumni) => (
            <SwiperSlide key={alumni.id}>
              <div className="alumni-card bg-white rounded p-4 h-100 d-flex flex-column">
                <div className="text-center mb-3">
                  <img
                    src={alumni.image}
                    alt={alumni.name}
                    className="alumni-img rounded-circle"
                    width={100}
                    height={100}
                  />
                </div>
                <div className="text-center mb-3">
                  <h5 className="alumni-name mb-1">{alumni.name}</h5>
                  <h6 className="mb-1">{alumni.field}</h6>
                </div>
                <p className="alumni-testimonial text-center mb-4">
                  "{alumni.testimonial.split(" ").slice(0, 20).join(" ")}
                  {alumni.testimonial.split(" ").length > 20 ? "..." : ""}"
                </p>
                {alumni.testimonial.split(" ").length > 5 && (
                  <button
                    className="btn btn-apply p-2 mt-auto"
                    style={{ fontSize: "0.9rem" }}
                    onClick={() => handleShowModal(alumni)}
                  >
                    Read More
                  </button>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* 👇 Bootstrap Modal */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedAlumni?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img
              src={selectedAlumni?.image}
              alt={selectedAlumni?.name}
              className="rounded-circle mb-3"
              width={100}
              height={100}
            />
            <h6 className="mb-2">{selectedAlumni?.field}</h6>
            <p className="mt-3">{selectedAlumni?.testimonial}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};


export default AlumniSec;
